import React from 'react';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import { buttonBtnTypeData, buttonSkinData } from '@luigiclaudio/ga-baseline-ui/button';
import MailchimpForm from './MailchimpForm';

var MailchimpSubscribeForm = function MailchimpSubscribeForm(_ref) {
  var baseUrl = _ref.baseUrl,
      u = _ref.u,
      id = _ref.id,
      buttonBtnType = _ref.buttonBtnType,
      buttonSkin = _ref.buttonSkin;
  var postUrl = baseUrl + "?u=" + u + "&id=" + id;
  return /*#__PURE__*/React.createElement(MailchimpSubscribe, {
    url: postUrl,
    render: function render(_ref2) {
      var subscribe = _ref2.subscribe,
          status = _ref2.status,
          message = _ref2.message;
      return /*#__PURE__*/React.createElement(MailchimpForm, {
        status: status,
        message: message,
        onSubmit: function onSubmit(values) {
          subscribe(values);
        },
        buttonBtnType: buttonBtnType,
        buttonSkin: buttonSkin
      });
    }
  });
};

MailchimpSubscribeForm.defaultProps = {
  buttonSkin: undefined,
  buttonBtnType: undefined
};
export default MailchimpSubscribeForm;